import { useShowCampaignById_new } from '@givebacks/api/store';
import { ClickableOptionsCard } from 'core/Components';
import { Modal, Stack, Text } from 'ui';

import { useCrowdfundingProvider } from '../../../../Context';
import { useEditPeerPageModalProvider } from './EditPeerPageModalProvider';

const EditPageModal = () => {
  const { opened, close, openModalById, meta } = useEditPeerPageModalProvider({
    id: 'base',
  });
  const { causeId, campaignId } = useCrowdfundingProvider();

  const { data: campaign } = useShowCampaignById_new({
    causeId,
    campaignId,
  });

  const isEditGoal =
    meta.peer.__type === 'participants'
      ? campaign?.participant_options.goal_setting === 'set_goal'
      : campaign?.team_options.registration_options.goal.requested;

  return (
    <Modal opened={opened} onClose={close} title="Edit Page">
      <Stack gap="lg">
        <Text fz="sm">
          What would you like to edit on your{' '}
          {meta.peer.__type === 'participants' ? 'participant' : 'team'} page?
        </Text>
        <ClickableOptionsCard>
          <ClickableOptionsCard.Row
            title="Banner Image"
            onClick={() => openModalById('bannerImage')}
          />
          <ClickableOptionsCard.Row
            title="Fundraising Description"
            onClick={() => openModalById('description')}
          />
          {isEditGoal && (
            <ClickableOptionsCard.Row
              title="Fundraising Goal"
              onClick={() => openModalById('goal')}
            />
          )}
          <ClickableOptionsCard.Row
            title="Donation Notifications"
            onClick={() => openModalById('notifications')}
          />
        </ClickableOptionsCard>
      </Stack>
    </Modal>
  );
};

export { EditPageModal };
